export const updateNotifierStrings = {
  updateFoundTitle: 'updateFoundTitle',
  updateFoundDescription: 'updateFoundDescription',
  refreshButtonText: 'refreshButtonText',
  componentName: 'updateNotifier',
};
